
import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  currentStep: string = 'calendar';
  isEditMode = false;
  
  steps = [
    { key: 'calendar', label: 'Calendar View' },
    { key: 'type', label: 'NDA/sNDA' },
    { key: 'category', label: 'Category' },
    { key: 'therapeutic', label: 'Therapeutic Area' },
    { key: 'results', label: 'Results' }
  ];

  constructor(private dashboardService: DashboardService) {}

  ngOnInit() {
    this.dashboardService.currentStep$.subscribe(step => {
      this.currentStep = step;
    });

    this.dashboardService.editMode$.subscribe(editMode => {
      this.isEditMode = editMode;
    });
  }

  get visibleSteps() {
    if (this.isEditMode) {
      // Hide the 'type' step when in edit mode
      return this.steps.filter(step => step.key !== 'type');
    }
    return this.steps;
  }

  navigateToStep(step: string) {
    if (this.canNavigateToStep(step)) {
      this.dashboardService.navigateToStep(step);
    }
  }

  canNavigateToStep(step: string): boolean {
    return this.dashboardService.canNavigateToStep(step);
  }
}
